import {
  AlignRow,
  IMessageFilteredListProps,
  MessageFilteredList,
} from '@framework/ui';
import { Divider } from 'antd';
import React from 'react';

export interface IFrontMessageFilteredListProps
  extends IMessageFilteredListProps {}

export function FrontMessageFilteredList(
  props: IFrontMessageFilteredListProps,
) {
  const { visible } = props;
  return (
    <div style={{ marginTop: visible ? 12 : 0 }}>
      <AlignRow justify="center">
        <MessageFilteredList {...props} />
      </AlignRow>
      {visible && <Divider style={{ margin: 0 }} />}
    </div>
  );
}
